import { render, staticRenderFns } from "./cashiers.vue?vue&type=template&id=5db7f131&scoped=true&"
import script from "./cashiers.vue?vue&type=script&lang=js&"
export * from "./cashiers.vue?vue&type=script&lang=js&"
import style0 from "./cashiers.vue?vue&type=style&index=0&id=5db7f131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7f131",
  null
  
)

export default component.exports